import { Filter } from "#sitis/internal/controllers/filters/models/Filter";
import { FilterPage } from "#sitis/internal/controllers/filters/models/FilterPage";
import { FilterPrices } from "#sitis/internal/controllers/filters/models/FilterPrices";
export class FiltersUseCase {
  constructor(agent) {
    this.agent = agent;
  }
  async getFiltersBySlug(path, slugs, filters, expanded, canceledOptions) {
    const queryArray = slugs.map((s) => `slugs[char][]=${s}`);
    if (expanded && !canceledOptions.prices_active) {
      queryArray.push("options[prices][active]=1");
    }
    if (expanded && !canceledOptions.categories_active) {
      queryArray.push("options[categories][active]=1");
    }
    if (expanded && !canceledOptions.categories_depth) {
      queryArray.push("options[categories][depth]=999");
    }
    let query = queryArray.join("&");
    if (query.length && filters.length) {
      query += "&";
    }
    if (filters) {
      query += filters.join("&");
    }
    if (query) {
      query = `?${query}`;
    }
    const response = await this.agent.get(`${path}${query}`).then((res) => res).catch((err) => {
      throw err;
    });
    const prices = new FilterPrices(response?._data?.prices || {}).toJSON();
    const options = (response?._data?.options || []).map((filter) => new Filter(filter).toJSON());
    const filterPages = (response?._data?.filterPages || []).map((filterPage) => new FilterPage(filterPage).toJSON());
    return {
      prices,
      options,
      filterPages
    };
  }
  async getFilterInfo(path) {
    return await this.agent.get(`/filter/info?path=${path}`).then((res) => res._data).catch(() => ({}));
  }
}
